export default __webpack_public_path__ + "static/media/790245970143084544.b67cd3cd.png";